import { render, staticRenderFns } from "./TiposTasa.vue?vue&type=template&id=7bda1029&scoped=true&lang=pug"
import script from "./TiposTasa.vue?vue&type=script&lang=js"
export * from "./TiposTasa.vue?vue&type=script&lang=js"
import style0 from "./TiposTasa.vue?vue&type=style&index=0&id=7bda1029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda1029",
  null
  
)

export default component.exports